<template>
	<!-- Temporärer Hotfix-Hinweis – nach Ende der Wartungsarbeiten entfernen (hier + Toolbar.vue) -->
	<ButtonIcon
		notext
		color="warning"
		icon="fa-solid fa-triangle-exclamation"
		icon-size="small"
		data-test="appBar__maintenance-btn"
		:tooltip="{
			text: `${translate('component.toast.info.maintenanceNotice.title')}: ${translate('component.toast.info.maintenanceNotice.notifications')}`,
			bottom: true,
		}"
	/>
</template>

<script setup lang="ts">
import ButtonIcon from 'components/templates/Base/ButtonIcon.vue'
import { useTranslate } from '@/composables/useTranslate'

const { translate } = useTranslate()
</script>
